import { Chapter, InstructorData } from './instructorData';
import firebase from 'firebase/app';
import 'firebase/firestore';
import { mapEnums } from '../util/mapEnums';
import {
  FirebaseChapter,
  FirebaseInstructorData,
} from '@ypp-portal/models/user/firebaseInstructorData';

const { original: mapping, reverse: reverse_mapping } = mapEnums(Chapter, FirebaseChapter);

export class InstructorDataConverter
  implements firebase.firestore.FirestoreDataConverter<InstructorData>
{
  toFirestore(modelObject: InstructorData): FirebaseInstructorData {
    return {
      ...modelObject,
      static: { ...modelObject.static, chapter: mapping[modelObject.static.chapter] },
    };
  }
  fromFirestore(
    snapshot: firebase.firestore.QueryDocumentSnapshot<FirebaseInstructorData>
  ): InstructorData {
    const data = snapshot.data();
    return {
      ...data,
      static: { ...data.static, chapter: reverse_mapping[data.static.chapter] },
    };
  }
}
